import { getPhoneCodeByTimezone } from 'timezone-phone-codes';
import ct from 'countries-and-timezones';

const getTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const getActiveDialCode = () => {
  return getPhoneCodeByTimezone(getTimezone()) || '';
};

export const getActiveCountryCode = () => {
  const country = ct.getCountryForTimezone(getTimezone()) || {};
  return country.id || '';
};

/**
 * Normalize phone number by removing leading zero after country code
 * Handles cases like +840888345217 → +84888345217
 * @param {string} phoneNumber - The phone number without dial code
 * @param {string} dialCode - The dial code (e.g., '+84')
 * @returns {string} Normalized phone number without leading zero
 */
export const normalizePhoneNumber = (phoneNumber, dialCode) => {
  if (!phoneNumber || !dialCode) return phoneNumber;

  // Remove all non-digit characters from phone number
  const cleaned = phoneNumber.replace(/\D/g, '');

  // If phone number starts with 0, remove it
  // This handles cases where user enters 0888345217 after selecting +84
  if (cleaned.startsWith('0')) {
    return cleaned.substring(1);
  }

  return cleaned;
};
